/**
 * ArtifactViewer
 * 
 * Renders the appropriate editor/viewer for each artifact type
 */

import React from 'react';
import type { Artifact } from '../artifacts';
import { DocumentEditor } from './editors/DocumentEditor';
import { EmailEditor } from './editors/EmailEditor';
import { ReportViewer } from './editors/ReportViewer';
import { DataViewer } from './editors/DataViewer';

interface ArtifactViewerProps {
  artifact: Artifact;
}

export const ArtifactViewer: React.FC<ArtifactViewerProps> = ({ artifact }) => {
  switch (artifact.type) {
    case 'document':
      return <DocumentEditor artifact={artifact} />;
    case 'email':
      return <EmailEditor artifact={artifact} />;
    case 'report':
      return <ReportViewer artifact={artifact} />;
    case 'data':
      return <DataViewer artifact={artifact} />;
    default:
      return (
        <div className="flex items-center justify-center h-full text-neutral-500">
          Unknown artifact type
        </div>
      );
  }
};

export default ArtifactViewer;

